import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { ROUTES } from "./constants";

const NotFound = lazy(
	() => import("../einstein/components/common/errors/NotFound"),
);
const ServerDown = lazy(
	() => import("../einstein/components/common/errors/ServerDown"),
);

export const errorRoutes: RouteObject[] = [
	{
		path: ROUTES.SERVER_DOWN,
		element: <ServerDown />,
	},
	{
		path: "*",
		element: <NotFound />,
	},
];
